module.exports = "../fonts/Back Chevron.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Back Chevron.svg
// module id = 63
// module chunks = 0